import { useState, useEffect, useContext } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { IoMdArrowDropdown, IoMdArrowDropleft } from "react-icons/io";
import { RiMenu3Fill, RiCloseFill } from "react-icons/ri";
import { FaFacebookF, FaRegUser } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import { AppContext } from "../../Context";
import logo from "../../assets/logo.png";
import { Img, UserLoginSection } from "../../components/Elements";
import "./css/Header.css";

export default function Header({ main_article }) {
    const { t } = useTranslation();
    let route = useLocation();
    const params = useParams();

    const { userData, siteData } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;
    const [data, setdata] = siteData;

    let site = data?.cats?.filter((r) => r?.name == params?.id);
    site = site?.length ? site[0] : {};

    const [menu, setmenu] = useState(false);
    const [effect, seteffect] = useState({});

    useEffect(() => {
        seteffect((p) => ({
            ...p,
            a: "open",
        }));

        setTimeout(() => {
            seteffect((p) => ({
                ...p,
                p: "open",
            }));
        }, 500);

        setTimeout(() => {
            seteffect((p) => ({
                ...p,
                h2: "open",
            }));
        }, 1000);

        setTimeout(() => {
            seteffect((p) => ({
                ...p,
                h1: "open",
            }));
        }, 1500);
    }, []);

    let splitLocation = location?.pathname?.split("/").pop();
    let pathname = params?.id;

    if (splitLocation == encodeURI(pathname)) {
        pathname = "/";
    } else {
        if (splitLocation) {
            pathname = "/" + splitLocation;
        } else {
            pathname = "/";
        }
    }

    return (
        <>
            <header
                className={`broun ${route?.pathname == "/" ? "main" : "mope"}`}
            >
                <div className="logoBox">
                    <div className="mainWidth">
                        <div className="f1">
                            <Link to={`/`}>
                                <Img
                                    className="logo"
                                    src={
                                        site?.logo?.length ? site?.logo[0] : ""
                                    }
                                />
                            </Link>

                            <div className="phoneNumberBox">
                                <p>
                                    {/* <Icon /> */}
                                    <span>{site?.name}</span>
                                </p>
                                <b>{site?.full?.substring(0, 35)}</b>
                            </div>
                        </div>

                        <div className="f2">
                            <a className="headMainBtns">
                                <FaFacebookF />
                                فيسبوك
                            </a>
                            <a className="headMainBtns">
                                <FaXTwitter />
                                اكس
                            </a>
                            {/* <a className='headMainBtns'>
                                <FaSearch />
                                {t("search")}
                            </a> */}

                            {userinfo?._id ? (
                                <UserLoginSection />
                            ) : (
                                <Link
                                    className="headMainBtns"
                                    to="/login"
                                    state={{ previousLocation: route }}
                                >
                                    <FaRegUser />
                                    الدخول
                                </Link>
                            )}
                        </div>
                    </div>
                </div>

                {route?.pathname != "/" && (
                    <div className="menuBox">
                        <div className="mainWidth">
                            <a
                                onClick={() => setmenu((p) => !p)}
                                className="mobile menuIconBox"
                            >
                                <RiMenu3Fill />
                            </a>

                            <div className="menuRightAND">
                                <nav className={menu ? "open" : "closed"}>
                                    <a
                                        onClick={() => setmenu((p) => !p)}
                                        className="mobile closeMenu"
                                    >
                                        <RiCloseFill />
                                    </a>

                                    <li
                                        class={`parent ${location?.pathname == `/site/${encodeURI(site?.name)}` && "selected"}`}
                                    >
                                        <a href={`/site/${site?.name}`}>
                                            {t("home")}
                                        </a>
                                    </li>

                                    {userinfo?.userlevel >= 3 &&
                                    site?.game &&
                                    site?.game_title ? (
                                        <li
                                            class={`parent ${location?.pathname?.startsWith(`/site/${encodeURI(site?.name)}/games`) && "selected"}`}
                                        >
                                            <a>
                                                {site?.game_title}
                                                <IoMdArrowDropdown />
                                            </a>
                                            <ul>
                                                <div>
                                                    <a
                                                        target="_blank"
                                                        href={site?.game}
                                                    >
                                                        <IoMdArrowDropleft />
                                                        {t("games_access")}
                                                    </a>
                                                    <a
                                                        href={`/site/${site?.name}/games`}
                                                    >
                                                        <IoMdArrowDropleft />{" "}
                                                        {t("games_title")}
                                                    </a>
                                                    <a href="/games_results">
                                                        <IoMdArrowDropleft />{" "}
                                                        {t("games_results")}
                                                    </a>
                                                    <a href="/myGames">
                                                        <IoMdArrowDropleft />
                                                        {t("my_games")}
                                                    </a>
                                                </div>
                                            </ul>
                                        </li>
                                    ) : null}

                                    {userinfo?.userlevel < 3 && (
                                        <li class={`parent`}>
                                            <a
                                                target="_blank"
                                                href={site?.game}
                                            >
                                                {site?.game_title}
                                            </a>
                                        </li>
                                    )}

                                    {site?.menu?.map((v, k) => {
                                        if (v?.sub?._id == false) {
                                            const ck = site?.menu?.filter(
                                                (r) => r?.sub?._id == v?._id,
                                            );

                                            let visible = true;
                                            if (
                                                v?.permission?.val >
                                                userinfo?.userlevel
                                            ) {
                                                visible = false;
                                            }

                                            if (visible) {
                                                return (
                                                    <li
                                                        key={k}
                                                        className={`parent ${location?.pathname?.startsWith(encodeURI(v?.link)) && "selected"}`}
                                                    >
                                                        <Link to={v?.link}>
                                                            {v?.name}{" "}
                                                            {ck?.length ? (
                                                                <IoMdArrowDropdown />
                                                            ) : (
                                                                false
                                                            )}
                                                        </Link>
                                                        {ck?.length ? (
                                                            <ul>
                                                                <div>
                                                                    {ck?.map(
                                                                        (
                                                                            vv,
                                                                            kk,
                                                                        ) => {
                                                                            return (
                                                                                <Link
                                                                                    key={
                                                                                        kk
                                                                                    }
                                                                                    to={
                                                                                        vv?.link
                                                                                    }
                                                                                >
                                                                                    <IoMdArrowDropleft />{" "}
                                                                                    {
                                                                                        vv?.name
                                                                                    }
                                                                                </Link>
                                                                            );
                                                                        },
                                                                    )}
                                                                </div>
                                                            </ul>
                                                        ) : (
                                                            false
                                                        )}
                                                    </li>
                                                );
                                            }
                                        }
                                    })}
                                </nav>
                                {userinfo?._id && <UserLoginSection />}
                            </div>
                        </div>
                    </div>
                )}
            </header>

            {pathname == "/" && (
                <div className="effectBox inside">
                    <div className="blend"></div>

                    <div className="mainWidth open">
                        {main_article?.title && (
                            <div className="textEffect">
                                {main_article?.title && (
                                    <h1 className={effect?.h1 || "closed"}>
                                        {main_article?.title}
                                    </h1>
                                )}
                                {main_article?.sub_title && (
                                    <h2 className={effect?.h2 || "closed"}>
                                        {main_article?.sub_title}
                                    </h2>
                                )}
                                {main_article?.short && (
                                    <p className={effect?.p || "closed"}>
                                        {main_article?.short}
                                    </p>
                                )}

                                <Link
                                    to={`/site/${params?.id}/content/${main_article?._id}`}
                                    className={`btn ${effect?.a || "closed"}`}
                                >
                                    {t("read_more")}
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}
